import React, { ReactElement } from "react";
import { Translate } from "react-redux-i18n";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { format } from "date-fns";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  Typography,
  Box,
  Grid,
  Tooltip,
} from "@mui/material";
import FontAwesomeIcon from "components/shared/FontAwesomeIcon";
import { savePayedCouponId } from "redux/coupon/couponSlice";
import { checkWalletPermissions, convertOddValue } from "services/utils";
import { openDialog } from "redux/dialog/dialogSlice";
import styles from './styles.module.scss'


export default function BettingDetail(): ReactElement {
  const playedCoupon = useAppSelector(state => state.coupon.playedCoupon);
  return (
    <Grid
      item
      sm={12}
      md={playedCoupon && playedCoupon.systems.length > 0 ? 6 : 12}
      lg={playedCoupon && playedCoupon.systems.length > 0 ? 6 : 12}
      className={styles.gridItem}
    >
      <Typography className={styles.headerTitleBetDet}>
        <Translate value="couponDetail.coupondetail" />
      </Typography>
      <Box className={styles.detailsContainer}>
        {/*First Grid Of Coupon Detail*/}
        <BettingDetailLeft />
        {/*Second Grid Of Coupon Detail*/}
        <BettingDetailRight />
      </Box>
    </Grid >
  )
}

function BettingDetailLeft(): ReactElement {
  const playedCoupon = useAppSelector(state => state.coupon.playedCoupon);

  return (
    <TableContainer className={styles.tableContainerLeft}>
      {playedCoupon &&
        <Table className={styles.tableContainerDetail}>
          <TableRow >
            <TableCell className={styles.tableCellHeaderColor}>
              <Translate value="couponDetail.user" />
            </TableCell>
            <TableCell
              align="right"
              className={styles.tableCell}
            >
              {playedCoupon.username}
            </TableCell>
          </TableRow>
          <TableRow >
            <TableCell className={styles.tableCellHeaderColor}>
              <Translate value="couponDetail.codeCoupon" />
            </TableCell>
            <TableCell
              align="right"
              className={styles.tableCell}
            >
              {playedCoupon.serial}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={styles.tableCellHeaderColor}>
              <Translate value="couponDetail.datePlayed" />
            </TableCell>
            <TableCell
              align="right"
              className={styles.tableCell}
            >
              {format(new Date(playedCoupon.created_at), `${process.env.REACT_APP_DATE_TIME_FORMAT}`)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={styles.tableCellHeaderColor}>
              <Translate value="couponDetail.bettingType" />
            </TableCell>
            <TableCell
              align="right"
              className={styles.tableCell}
            >
              <Translate value={`bettingTable.${playedCoupon.coupon_type.label}S`} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={styles.tableCellHeaderColor}>
              <Translate value="couponDetail.state" />
            </TableCell>
            <TableCell
              align="right"
              className={styles.tableCell}
            >
              <Translate value={`couponDetail.${playedCoupon.coupon_state.label}`} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={styles.tableCellHeaderColor}>
              <Translate value="couponDetail.playImport" />
            </TableCell>
            <TableCell
              align="right"
              className={styles.tableCell}
            >
              {(playedCoupon.bet_amount / playedCoupon.currency.divider).toFixed(playedCoupon.currency.decimal)}{" "}
              {(playedCoupon.bet_amount !== 0 ? playedCoupon.currency.symbol : playedCoupon.currency.symbol)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={styles.tableCellHeaderColor}>
              <Translate value="couponDetail.dateClosed" />
            </TableCell>
            <TableCell
              align="right"
              className={styles.tableCell}
            >
              {playedCoupon.closed_at !== null && format(new Date(playedCoupon.closed_at), `${process.env.REACT_APP_DATE_TIME_FORMAT}`)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={styles.tableCellHeaderColor}>
              <Translate value="couponDetail.win" />
            </TableCell>
            <TableCell
              align="right"
              className={styles.tableCell}
            >
              {(playedCoupon.win_amount / playedCoupon.currency.divider).toFixed(playedCoupon.currency.decimal)}{" "}
              {(playedCoupon.win_amount !== 0 ? playedCoupon.currency.symbol : playedCoupon.currency.symbol)}
            </TableCell>
          </TableRow>
        </Table>
      }
    </TableContainer>
  )
}
function BettingDetailRight(): ReactElement {
  const dispatch = useAppDispatch();
  const playedCoupon = useAppSelector(state => state.coupon.playedCoupon);
  const permissions = useAppSelector((state) => state.auth.permissions);

  const handlePayed = (id: string) => {
    dispatch(savePayedCouponId(id))
    dispatch(openDialog({ type: "payed" }))
  }

  return (
    <TableContainer className={styles.tableContainerRight}>
      {playedCoupon &&
        <Table className={styles.tableContainerDetail}>
          {(playedCoupon.coupon_type.id === 1 || playedCoupon.coupon_type.id === 2) &&
            <TableRow >
              <TableCell
                className={styles.tableCellHeaderColor}
              >
                <Translate value="couponDetail.bonus" />
              </TableCell>
              <TableCell align="right"
                className={styles.tableCell}
              >
                {(playedCoupon.bonus_max / playedCoupon.currency.divider).toFixed(playedCoupon.currency.decimal)}{" "}
                {(playedCoupon.bonus_max !== 0 ? playedCoupon.currency.symbol : playedCoupon.currency.symbol)}
              </TableCell>
            </TableRow>
          }
          {(playedCoupon.coupon_type.id === 3 || playedCoupon.coupon_type.id === 4) &&
            <>
              {playedCoupon.coupon_type.id === 4 &&
                <>
                  <TableRow>
                    <TableCell
                      className={styles.tableCellHeaderColor}
                    >
                      {playedCoupon.coupon_type.id === 4
                        ? <Translate value="couponDetail.detailsOdd" />
                        : <Translate value="coupon.odd" />
                      } Min.

                    </TableCell>
                    <TableCell align="right"
                      className={styles.tableCell}
                    >
                      {convertOddValue(playedCoupon.odds_min)}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={styles.tableCellHeaderColor}
                    >
                      {playedCoupon.coupon_type.id === 4
                        ? <Translate value="couponDetail.detailsOdd" />
                        : <Translate value="coupon.odd" />
                      } Max.
                    </TableCell>
                    <TableCell align="right"
                      className={styles.tableCell}
                    >
                      {convertOddValue(playedCoupon.odds_max)}
                    </TableCell>
                  </TableRow>
                </>}
              <TableRow>

                <TableCell
                  className={styles.tableCellHeaderColor}
                >
                  <Translate value="couponDetail.bonus" /> Min.
                </TableCell>
                <TableCell align="right"
                  className={styles.tableCell}
                >
                  {(playedCoupon.bonus_min / playedCoupon.currency.divider).toFixed(playedCoupon.currency.decimal)}{" "}
                  {(playedCoupon.bonus_max !== 0 ? playedCoupon.currency.symbol : playedCoupon.currency.symbol)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={styles.tableCellHeaderColor}
                >
                  <Translate value="couponDetail.bonus" /> Max.
                </TableCell>
                <TableCell align="right"
                  className={styles.tableCell}
                >
                  {(playedCoupon.bonus_max / playedCoupon.currency.divider).toFixed(playedCoupon.currency.decimal)}{" "}
                  {(playedCoupon.bonus_max !== 0 ? playedCoupon.currency.symbol : playedCoupon.currency.symbol)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={styles.tableCellHeaderColor}
                >
                  <Translate value="couponDetail.potentialWin" /> Col. Min.
                </TableCell>
                <TableCell align="right"
                  className={styles.tableCell}
                >
                  {(playedCoupon.min_potential_win / playedCoupon.currency.divider).toFixed(playedCoupon.currency.decimal)}{playedCoupon.currency.symbol}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={styles.tableCellHeaderColor}
                >
                  <Translate value="couponDetail.potentialWin" /> Col. Max.
                </TableCell>
                <TableCell align="right"
                  className={styles.tableCell}
                >
                  {(playedCoupon.max_potential_win / playedCoupon.currency.divider).toFixed(playedCoupon.currency.decimal)} {playedCoupon.currency.symbol}
                </TableCell>
              </TableRow>
            </>
          }
          {(playedCoupon.coupon_type.id === 1 || playedCoupon.coupon_type.id === 2) &&
            <>
              <TableRow>
                <TableCell
                  className={styles.tableCellHeaderColor}
                >
                  <Translate value="coupon.totalOdd" />
                </TableCell>
                <TableCell align="right"
                  className={styles.tableCell}
                >
                  {playedCoupon?.odds_max.toFixed(2)}
                </TableCell>
              </TableRow>

            </>
          }
          <TableRow>
            <TableCell
              className={styles.tableCellHeaderColor}
            >
              <Translate value="couponDetail.maxWin" />
            </TableCell>
            <TableCell align="right"
              className={styles.tableCell}
            >
              <Box className={styles.winMaxContainer}>
                {playedCoupon.winner && permissions && checkWalletPermissions(permissions, "game.betassist") &&
                  <>
                    {
                      playedCoupon.payed ?
                        <Box className={styles.payedIcon}>
                          <Tooltip
                            title={playedCoupon.payed_at ? format(new Date(`${playedCoupon.payed_at}`),
                              `${process.env.REACT_APP_DATE_TIME_FORMAT}`) : ""}
                            placement="top"
                          >
                            <Box className={styles.payedIcon}>
                              <FontAwesomeIcon name="money-bill" type="fas" color="green" />
                            </Box>
                          </Tooltip>
                        </Box>
                        :
                        <Box
                          onClick={() => handlePayed(playedCoupon.id)}
                          className={styles.payedIcon}
                        >
                          <FontAwesomeIcon name="money-bill" type="fas" />
                        </Box>
                    }
                  </>
                }
                <Box className={styles.winMaxValue}>
                  {(playedCoupon.win_max / playedCoupon.currency.divider).toFixed(playedCoupon.currency.decimal)}{" "}
                  {(playedCoupon.win_max !== 0 ? playedCoupon.currency.symbol : playedCoupon.currency.symbol)}
                </Box>
              </Box>
            </TableCell>
          </TableRow>

        </Table>
      }
    </TableContainer>
  )
}